/**
 * @deprecated This module is deprecated and will be removed in future versions.
 */

import { getInstance } from '../app/app.module';
import type { CartController } from './cart.controller';
import { CartModule } from './cart.module';
import { CartSelectors } from './cart.selectors';

export const addToCart = (
  _context: unknown,
  ...params: Parameters<CartController['addToCart']>
): void => {
  const cartModule = getInstance(CartModule);
  const cartController = cartModule?.controller;

  cartController?.addToCart(...params);
};

export const getCartSelectorAndUpdateAction = ():
  | ReturnType<CartSelectors['getCartSelectorAndUpdateAction']>
  | undefined => {
  const cartSelectors = getInstance(CartSelectors);

  return cartSelectors?.getCartSelectorAndUpdateAction();
};
